var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33333 12.25V11.0833C9.33333 10.4645 9.0875 9.871 8.64992 9.43342C8.21233 8.99583 7.61884 8.75 7 8.75H3.5C2.88116 8.75 2.28767 8.99583 1.85008 9.43342C1.4125 9.871 1.16667 10.4645 1.16667 11.0833V12.25",
    stroke: "#868C98",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.25 6.41667C6.53866 6.41667 7.58333 5.372 7.58333 4.08333C7.58333 2.79467 6.53866 1.75 5.25 1.75C3.96134 1.75 2.91667 2.79467 2.91667 4.08333C2.91667 5.372 3.96134 6.41667 5.25 6.41667Z",
    stroke: "#868C98",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8333 12.25V11.0833C12.8329 10.5663 12.6609 10.0641 12.3441 9.65552C12.0274 9.24692 11.5839 8.95508 11.0833 8.82583",
    stroke: "#868C98",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.33333 1.82583C9.83524 1.95434 10.2801 2.24624 10.5978 2.65551C10.9155 3.06479 11.0879 3.56815 11.0879 4.08625C11.0879 4.60435 10.9155 5.10771 10.5978 5.51699C10.2801 5.92626 9.83524 6.21816 9.33333 6.34667",
    stroke: "#868C98",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.bf0f34961ac6670ab0d943994b78c9ed.svg";
export { ForwardRef as ReactComponent };